<template>
    <div class="tevalis-config-container">
        <div class="header m-bottom-2rem">
            <span>Tevalis configuration</span>
        </div>
        <template v-if="configurationStep == 1">

            <div class="content">
                <div class="field__wrapper">
                    <span class="d-block m-bottom-10">Company ID</span>
                    <el-input v-model="form.companyId" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
                </div>
                <div class="field__wrapper">
                    <span class="d-block m-bottom-10">GUID</span>
                    <el-input v-model="form.guid" class="peiso-input-default center-align h-55 b-radius-10"></el-input>
                </div>
            </div>

            <div class="bottom-button d-flex gap-30">
                <el-button type="peiso-white-border-only w-100" @click="buttonAction('back')">Back</el-button>
                <el-button v-if="!loading" type="peiso-primary-pink-border-only w-100" @click="buttonAction('confirm', form)">Confirm</el-button>
                <el-button v-if="loading" type="peiso-primary-pink-border-only w-100"><i class="el-icon-loading"></i> Loading...</el-button>
            </div>
        </template>

        <template v-if="configurationStep == 2">
            <div class="field__wrapper configuration-two m-bottom-2rem">
                <div class="d-flex gap-32 m-bottom-1rem">
                    <div class="d-flex align-items-center gap-10">
                        <span class="text-nowrap">Site Location</span>
                        <el-dropdown trigger="click" class="left-align" style="width: 300px;">
                            <el-button type="peiso-default" class="w-100">
                                {{ selectedSite.name ? selectedSite.name : '' }}
                                <div class="img-container">
                                    <img src="@/assets/arrow-down.svg" alt="">
                                </div>
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>

                                    <el-dropdown-item v-for="(item, i) in sites" :key="`sites-${i}`" @click.native="selectedSite = item">{{ item.name }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                    <div class="d-flex align-items-center gap-10">
                        <span class="text-nowrap">Revenue Group</span>
                        <el-dropdown trigger="click" class="left-align" style="width: 175px;">
                            <el-button type="peiso-default" class="w-100">
                                {{ selectedRev }}
                                <div class="img-container">
                                    <img src="@/assets/arrow-down.svg" alt="">
                                </div>
                            </el-button>

                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click.native="selectedRev = 'Both'">Both</el-dropdown-item>
                                    <el-dropdown-item @click.native="selectedRev = 'Food'">Food</el-dropdown-item>
                                    <el-dropdown-item @click.native="selectedRev = 'Beverage'">Beverage</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </div>

                <div class="d-flex gap-32 w-100">
                    <div class="d-flex flex-column gap-10 w-100">
                        <span>Please select Terminals</span>
                        <div class="category-list px-20 py-10">
                            <el-checkbox-group v-model="checkedTerminals" class="peiso-checkbox-design-2 alata" @change="handleSelectedFood">
                                <el-checkbox v-for="(item, i) in terminals" :key="`terminals-${i}`" :label="item" :value="item">{{ item }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="d-flex flex-column gap-10 w-100">
                        <span>Please select Food Categories</span>
                        <div class="category-list px-20 py-10">
                            <el-checkbox-group v-model="checkedFood" class="peiso-checkbox-design-2 alata" @change="handleSelectedFood">
                                <el-checkbox v-for="(item, i) in categories" :key="`foodcategories-${i}`" :label="item" :value="item">{{ `${item.typeId} - ${item.name}` }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>

                    <div class="d-flex flex-column gap-10 w-100">
                        <span>Please select Beverage Categories</span>

                        <div class="category-list px-20 py-10">

                            <el-checkbox-group v-model="checkedBeverage" class="peiso-checkbox-design-2 alata" @change="handleSelectedBev">
                                <el-checkbox v-for="(item, i) in categories" :key="`bevcategories-${i}`" :label="item" :value="item">{{ `${item.typeId} - ${item.name}` }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bottom-button d-flex gap-30 px-3rem">
                <el-button type="peiso-white-border-only w-100" @click="buttonAction('close')">Close</el-button>
                <el-button v-if="!loading" type="peiso-primary-pink-border-only w-100" @click="completeBinding()">Confirm</el-button>
                <el-button v-if="loading" type="peiso-primary-pink-border-only w-100"><i class="el-icon-loading"></i> loading...</el-button>
            </div>
        </template>

    </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/colors.scss';
@import 'static/scss/fonts/fonts';
@import 'static/scss/scrollbar';
    .tevalis-config-container {
        .header {
            @include alata-fonts(28px, 150%, 500, $white)
        }

        .content {
            margin: 30px 0;
            .field__wrapper {
                @include alata-fonts(16px, normal, 400, $white) {
                    padding: 10px 1rem;
                }

                border-style: solid;
                border-width: 1px 1px 0px 1px;
                border-color: $gray8;

                &:last-child {
                    border-bottom-width: 1px;
                }


                .peiso-input-default {
                    .el-input__inner {

                        font-family: "Alata", sans-serif;
                        font-weight: 500;
                        font-size: 16px;
                    }
                }
            }



        }

        .bottom-button {
            button {
                margin: 0px;
                font-family: "Alata", sans-serif;
                font-weight: 500;
                font-size: 26px;

            }
        }

        .configuration-two {
            span {
                @include alata-fonts(16px, normal, 400, $white)

            }

            .el-button--peiso-default {
                @include alata-fonts(16px, normal, 400, $white) {
                    height: 55px;
                    border-radius: 10px;
                }

            }

            .left-align {
                .el-button--peiso-default {
                    display: flex;
                    align-items: center;
                    justify-content: left;
                }
            }

            .category-list {
                border-radius: 10px;
                background: $black2;
                min-height: 300px;
                max-height: 480px;
                overflow: hidden auto;
                &::-webkit-scrollbar {
                    @extend .scrollbar;
                }

                &::-webkit-scrollbar-track {
                    @extend .scrollbar-track;
                }

                &::-webkit-scrollbar-thumb {
                    @extend .scrollbar-thumb;
                }
            }

        }

    }
</style>

<script>
import { Step } from 'element-ui';

export default {
    data() {
        return {
            form: {
                companyId: '',
                guid: ''

                // companyId: '2264',
                // devId: 'peiso-250624-adbea816-6215-4077-85c1-aff241cf67b7',
                // guid: '789d6cbb-981a-426b-ae59-1f262f71d447'
            
            },
            checkedFood: [],
            checkedBeverage: [],
            checkedTerminals: [],
            selectedSite: {},
            selectedRev: ''
        }
    },

    props: {
        loading: {
            default: false
        },
        configurationStep: {
            default: 1
        },
        categories: {
            default: []
        },
        sites: {
            default: []
        },
        terminals: {
            default: []
        }
    },

    watch: {
      selectedSite() {
        if (this.selectedSite) {
          console.log(this.selectedSite);
          this.$emit('siteChange', this.selectedSite.id)
        }
      },

      categories(val) {
        if (val && val.length) {
            this.checkedBeverage = val
            this.checkedFood = val
        }
      },

      terminals(val) {
        if (val && val.length) {
            this.checkedTerminals = val
        }
      }
    },

    methods: {
        buttonAction(action, data = null) {
            this.$emit(action, data)
        },

        handleSelectedFood(check) {
            this.checkedFood = check
        },

        handleSelectedBev(check) {
            this.checkedBeverage = check
        },

        completeBinding() {

            this.$emit('complete', {
                siteId: this.selectedSite.id,
                profitTarget: {
                    profitTarget: 1000,
                    profitTargetType: 0,
                    type: 0,
                    revenueTargetThreshold: 100
                },
                foodCategories: this.checkedFood,
                beverageCategories: this.checkedBeverage,
                revenueGroupId: this.selectedRev,
                terminals: this.checkedTerminals
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/tevalisConfiguration.vue